import { ViewportScroller } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _ from 'lodash';;
import { report } from 'process';
import { Subscription } from 'rxjs';
import { NewFilterService } from 'src/app/services/new-filter.service';

@Component({
    selector: 'app-static-popup-status',
    templateUrl: './static-popup-status.component.html',
    styleUrls: ['./static-popup-status.component.scss'],
    standalone: false
})
export class StaticPopupStatusComponent implements OnInit, OnDestroy {
  // patient_status="";
  selectedReasonAsIcon = "reason_tick";
  patient_status_key: any;
  patient_reason_code: any
  reqSubcription: Subscription[] = []
  api_key: any
  dialogData: any
  patientStatusChange: any[] = []
  patientReasons: any[] = []
  concatCurrentData: any
  dataLoaded = true;
  matDialogClose = false;

  constructor(
    private newFilterService: NewFilterService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    this.newFilterService.currentData.subscribe(data => {
      this.dialogData = data;
    })
    // debugger
    this.concatCurrentData = this.dialogData.data[this.dialogData.actionData.field]
    let data = this.dialogData.actionData.staticStatus
    this.patientReasons = data.map((m:any)=> {
      return {...m, "patient_reason_code_desc": m.col_value}
    });
    this.defaultPatientReason = this.patientReasons;
    this.dialogData.patient_reason_status = this.concatCurrentData;
    // this.dialogData.patient_case_status = "FRM";

    // this.api_key = this.dialogData.api_key
    // // this.concatCurrentData = this.dialogData.patient_case_status + '-' + this.dialogData.patient_reason_status
    // this.concatCurrentData =  this.dialogData.patient_reason_status

    // if (this.dialogData) {
    //   this.loadApiData()
    // }
  }
  patient_status: any
  selectStatus(opt: any) {
     
    let options = this.patientStatusChange.find((res: any) => res.patient_status == opt.patient_status)
    if (options) {
      this.dialogData.patient_case_status = options.patient_status
      this.patientReasons = options.patient_reason
      this.defaultPatientReason = this.patientReasons;
      this.patietStatusSearch = '';
      this.patient_reason_code = ''
      this.dialogData.patient_reason_status = ''
    }
  }

  selectReason(a: any, idx:any) {
    this.patient_status_key = a.patient_status_dim_key
    this.patient_reason_code = a.patient_reason_code
    this.dialogData.patient_reason_status = a.patient_reason_code_desc
  }
  

  

  scrollToBlue(id:any) {
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      })
    }, 500);
  }

  patietStatusSearch:any;
  defaultPatientReason:any;

  patietStatusSearchChange() {
    if(this.patietStatusSearch) {
      this.patientReasons =  this.filterMessagesByKeys(this.defaultPatientReason, ['patient_reason_code_desc'], this.patietStatusSearch);
    } else {
      this.patientReasons = this.defaultPatientReason;
    }
  }

  filterMessagesByKeys(messages: any[], filterKeys: string[], searchText: string): any[] {
    return messages.filter((obj) => {
      return filterKeys.some((key) => {
        return obj[key] && obj[key].toString().toLowerCase().includes(searchText.toLowerCase());
      });
    });
  }

  ngOnDestroy() {
    this.reqSubcription.forEach((res: any) => res.unsubscribe());
  }
}
